/* Progressive enhancement: without JS each logo is a native disclosure containing the actual campaign list. */
(() => {
  const initialized = new WeakSet();
  function init(root) {
    root.querySelectorAll('[data-pq-rewards-directory]').forEach(section => {
      if (initialized.has(section)) return;
      const dialog = section.querySelector('.pq-sf-rewards__dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      initialized.add(section);
      let opener = null;
      let oldOverflow = null;
      const heading = dialog.querySelector('[id^="pq-rewards-dialog-title-"]');
      const body = dialog.querySelector('[data-pq-dialog-body]');
      const closeButton = dialog.querySelector('[data-pq-dialog-close]');
      const finish = () => {
        if (oldOverflow !== null) { document.body.style.overflow = oldOverflow; oldOverflow = null; }
        body.replaceChildren();
        if (opener?.isConnected) opener.focus();
        opener = null;
      };
      dialog.addEventListener('close', finish);
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      section.querySelectorAll('.pq-sf-rewards__brand').forEach(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.pq-sf-rewards__disclosure');
        if (!summary || !content) return;
        summary.addEventListener('click', event => {
          event.preventDefault();
          opener = summary;
          heading.textContent = content.querySelector('h4')?.textContent || summary.getAttribute('aria-label') || 'Campaigns';
          const intro = content.querySelector('p');
          const list = content.querySelector('ul');
          body.replaceChildren(...[intro, list].filter(Boolean).map(item => item.cloneNode(true)));
          if (details.open) details.open = false;
          oldOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          closeButton.focus();
        });
        details.classList.add('is-enhanced');
      });
      section.addEventListener('shopify:section:unload', () => { if (dialog.open) dialog.close(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
